import * as Yup from 'yup';

import { createEmailValidation } from '@/utils/emailValidation';

const createPhoneValidation = () => {
  return Yup.string()
    .required('El teléfono es requerido')
    .test('phone-format', function (value) {
      if (!value) return false;

      const phoneConfig: Record<string, { prefix: string; digits: number }> = {
        '+52': { prefix: '+52', digits: 10 },
        '+51': { prefix: '+51', digits: 9 },
        '+57': { prefix: '+57', digits: 10 },
        '+56': { prefix: '+56', digits: 9 },
      };

      const matchedConfig = Object.values(phoneConfig).find((cfg) => value.startsWith(cfg.prefix));

      if (!matchedConfig) {
        return this.createError({
          message: 'Debe incluir un código de país válido (+52, +56, +57, +51)',
        });
      }

      const phoneNumber = value.substring(matchedConfig.prefix.length);

      if (!/^\d+$/.test(phoneNumber)) {
        return this.createError({
          message: `El número debe tener solo dígitos después de ${matchedConfig.prefix}`,
        });
      }

      if (phoneNumber.length !== matchedConfig.digits) {
        return this.createError({
          message: `El número debe tener ${matchedConfig.prefix} + ${matchedConfig.digits} dígitos`,
        });
      }

      return true;
    });
};

export const savedAddressFormSchema = Yup.object().shape({
  alias: Yup.string()
    .required('El alias es requerido')
    .min(2, 'Debe tener al menos 2 caracteres')
    .max(100, 'Máximo 100 caracteres'),
  type: Yup.mixed<'origin' | 'destination' | 'both'>()
    .oneOf(['origin', 'destination', 'both'], 'Tipo no válido')
    .required('El tipo de dirección es requerido'),
  address: Yup.string()
    .required('La calle es requerida')
    .min(3, 'Debe tener al menos 3 caracteres')
    .max(250, 'Máximo 250 caracteres'),
  street_number: Yup.string().optional().nullable(),
  interior_number: Yup.string().optional().nullable(),
  colony: Yup.string().optional().nullable(),
  zip_code: Yup.string()
    .required('El código postal es requerido')
    .min(3, 'Mínimo 3 caracteres')
    .max(20, 'Máximo 20 caracteres'),
  city: Yup.string()
    .required('La ciudad es requerida')
    .min(2, 'Mínimo 2 caracteres')
    .max(100, 'Máximo 100 caracteres'),
  state: Yup.string().optional().nullable(),
  country: Yup.string().required('El país es requerido'),
  latitude: Yup.number().required('Coordenada requerida'),
  longitude: Yup.number().required('Coordenada requerida'),
  references: Yup.string().max(250, 'Máximo 250 caracteres').optional().nullable(),
  contact: Yup.object().shape({
    first_name: Yup.string()
      .required('El nombre es requerido')
      .min(2, 'Mínimo 2 caracteres')
      .max(50, 'Máximo 50 caracteres'),
    last_name: Yup.string()
      .required('El apellido es requerido')
      .min(2, 'Mínimo 2 caracteres')
      .max(50, 'Máximo 50 caracteres'),
    phone: createPhoneValidation(),
    email: createEmailValidation('Debe tener un formato de correo válido'),
  }),
});

export type SavedAddressFormData = Yup.InferType<typeof savedAddressFormSchema>;
